import { useVerifyAnalysis, useAddToSanitizer } from './mutations';

export default function useAnalysisManagerActions() {
  const { mutate: verifyAnalysis, isPending: isVerifying } =
    useVerifyAnalysis();
  const { mutate: addToSanitizer, isPending: isAdding } = useAddToSanitizer();

  return {
    handleVerify: verifyAnalysis,
    handleAddToSanitizer: addToSanitizer,
    isPending: isVerifying || isAdding,
  };
}
